module.exports = __webpack_public_path__ + "assets/img/block-left-hover-fd71d616.png";